import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BannerImg from "../../../images/locationgcc/sa/web-sa/experienced-sa.webp";

function whychoose(props) {
  return (
    <div
      className="whychoose why_choosedubai p-100"
      style={{ backgroundImage: `url(${BannerImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={5}>
            <h2>
              Get Customized Web Solutions by Collaborating with Our
              <span> Website Development Company</span>
            </h2>
            <p>
              Partner up with our website development company for tailored web
              solutions in Saudi Arabia. Our expertise in custom website
              development ensures unique and effective digital solutions for
              your business needs. With a focus on user experience and
              cutting-edge technology, we deliver standout results that drive
              growth.
            </p>
            <p>
              As a leading provider of web development services in KSA, we
              understand the diverse needs of businesses in the region. From
              e-commerce platforms to corporate websites, we offer comprehensive
              development services to meet your requirements. Our experienced
              team of developers delivers innovative solutions tailored to your
              specific goals. With our collaborative approach and commitment to
              excellence, we ensure your website stands out in the competitive
              digital landscape.
            </p>
            <p>
              So, experience the difference of working with one of the top
              website development companies in Saudi Arabia. Let us help you
              achieve your digital goals by improving your online presence with
              our customized web solutions.
            </p>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="choose-main">
              <div className="choose-box">
                <div className="choose-num">
                  300+<span>Apps Developed</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  65+<span>Review</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  35+<span>Industries Served</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default whychoose;
